import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { RenderFeatureFlag } from '~/components/render-feature-flag/RenderFeatureFlag';

export interface DownloadButtonProps {
  onClick: () => void;
}

export const DownloadButton = ({ onClick }: DownloadButtonProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <RenderFeatureFlag requiredFlag={'drawer_download'}>
      <Button
        iconName="CloudArrowDown"
        label={t('widget:download')}
        onClick={onClick}
        variant="empty"
        size="xsmall"
      />
    </RenderFeatureFlag>
  );
};
